export default __webpack_public_path__ + "static/media/registerBG.9925ed54.jpg";